import Config from 'conf';
import bindSocketEvents from './binds';

export default socketMiddleware => {
    bindSocketEvents(socketMiddleware);
    let socketEmit = socketMiddleware.socketEmit.bind(socketMiddleware);
    let socketOn = socketMiddleware.socketOn.bind(socketMiddleware);

    return {
        genericProductCheckStatus: async function(productMac, productType) {
            switch (productType) {
                case 'fhe_product':
                    return await this.fheProductCheckStatus(productMac, productType);
                case 'drive_elec':
                    return await this.driveElecCheckStatus(productMac, productType);
                case 'sensor':
                    return await this.sensorCheckStatus(productMac, productType);
                case 'smart_plug':
                    return await this.smartPlugCheckStatus(productMac, productType);
                case 'heat_and_cool':
                    return await this.heatandcoolCheckStatus(productMac, productType);
            }
        },
        fheProductCheckStatus: function(fheProduct_mac, fheProduct_type) {
            return new Promise((resolve, reject) => {
                let fheProductStatus = args => {
                    if (fheProduct_mac === args.fheProduct_mac && fheProduct_type === args.fheProduct_type) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('fheProductStatus', fheProductStatus);
                        return resolve(args);
                    }
                };
                socketOn('fheProductStatus', fheProductStatus);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('fheProductStatus', fheProductStatus);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);
                socketEmit('fheProductCheckStatus', { fheProduct_mac, fheProduct_type });
            });
        },
        driveElecCheckStatus: function(drive_elec_mac) {
            return new Promise((resolve, reject) => {
                let driveElecStatus = args => {
                    if (drive_elec_mac === args.drive_elec_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('driveElecStatus', driveElecStatus);
                        return resolve(args);
                    }
                };
                socketOn('driveElecStatus', driveElecStatus);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('driveElecStatus', driveElecStatus);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);
                socketEmit('driveElecCheckStatus', { drive_elec_mac });
            });
        },
        sensorCheckStatus: function(fheProduct_mac, fheProduct_type) {
            return new Promise((resolve, reject) => {
                let sensorStatus = args => {
                    if (fheProduct_mac === args.fheProduct_mac && fheProduct_type === args.fheProduct_type) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('fheProductStatus', sensorStatus);
                        return resolve(args);
                    }
                };
                socketOn('fheProductStatus', sensorStatus);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('sensorStatus', sensorStatus);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);
                socketEmit('sensorClientCheckStatus', { fheProduct_mac, fheProduct_type });
            });
        },
        smartPlugCheckStatus: function(smart_plug_mac) {
            return new Promise((resolve, reject) => {
                let smartPlugStatus = args => {
                    if (smart_plug_mac === args.wifiPlug_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('smartPlugStatus', smartPlugStatus);
                        return resolve(args);
                    }
                };
                socketOn('smartPlugStatus', smartPlugStatus);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('smartPlugStatus', smartPlugStatus);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);
                socketEmit('smartPlugCheckStatus', { smart_plug_mac });
            });
        },
        heatandcoolCheckStatus: function(fheProduct_mac, fheProduct_type) {
            return new Promise((resolve, reject) => {
                let fheProductStatus = args => {
                    if (fheProduct_mac === args.fheProduct_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('fheProductStatus', fheProductStatus);
                        return resolve(args);
                    }
                };
                socketOn('fheProductStatus', fheProductStatus);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('fheProductStatus', fheProductStatus);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);
                socketEmit('fheProductCheckStatus', { fheProduct_mac, fheProduct_type });
            });
        },

        productCheckStatus: function(fheCenter_mac, product_type, product_identifier, module_type) {
            return new Promise((resolve, reject) => {
                let productCheckStatusFeedback = args => {
                    if (
                        fheCenter_mac === args.fheCenter_mac &&
                        product_type === args.product_type &&
                        product_identifier === args.product_identifier &&
                        module_type === args.module_type
                    ) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('productStatus', productCheckStatusFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('productStatus', productCheckStatusFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('productCheckStatusFeedback', productCheckStatusFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('productCheckStatus', { fheCenter_mac, product_type, product_identifier, module_type });
            });
        },
        updateProductModuleLabel: function(fheCenter_mac, product_identifier, product_type, module_type, code, label) {
            return new Promise((resolve, reject) => {
                let updateProductModuleLabelFeedback = args => {
                    if (
                        fheCenter_mac === args.fheCenter_mac &&
                        product_identifier === args.product_identifier &&
                        product_type === args.product_type &&
                        module_type === args.module_type &&
                        code === args.code
                    ) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('updateProductModuleLabelFeedback', updateProductModuleLabelFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('updateProductModuleLabelFeedback', updateProductModuleLabelFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('updateProductModuleLabelFeedback', updateProductModuleLabelFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('updateProductModuleLabel', { fheCenter_mac, product_identifier, product_type, module_type, code, label });
            });
        },
        updateThreshold: function(fheCenter_mac, product_identifier, module_type, code, threshold) {
            return new Promise((resolve, reject) => {
                let updateFheProductThresholdFeedback = args => {
                    if (
                        fheCenter_mac === args.fheCenter_mac &&
                        product_identifier === args.product_identifier &&
                        module_type === args.module_type &&
                        args.thresholds_config
                    ) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('updateFheProductThresholdFeedback', updateFheProductThresholdFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('updateFheProductThresholdFeedback', updateFheProductThresholdFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('updateFheProductThresholdFeedback', updateFheProductThresholdFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('updateFheProductThreshold', { fheCenter_mac, product_identifier, module_type, code, threshold });
            });
        },
        updateGain: function(fheCenter_mac, product_identifier, module_type, code, gain) {
            return new Promise((resolve, reject) => {
                let updateFheProductGainFeedback = args => {
                    if (
                        fheCenter_mac === args.fheCenter_mac &&
                        product_identifier === args.product_identifier &&
                        module_type === args.module_type &&
                        args.gains_config
                    ) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('updateFheProductGainFeedback', updateFheProductGainFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('updateFheProductGainFeedback', updateFheProductGainFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('updateFheProductGainFeedback', updateFheProductGainFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('updateFheProductGain', { fheCenter_mac, product_identifier, module_type, code, gain });
            });
        },
        updatePolarity: function(fheCenter_mac, product_identifier, module_type, code, reversePolarity) {
            return new Promise((resolve, reject) => {
                let updateFheProductPolarityFeedback = args => {
                    if (
                        fheCenter_mac === args.fheCenter_mac &&
                        product_identifier === args.product_identifier &&
                        module_type === args.module_type &&
                        args.reverse_polarity_config
                    ) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('updateFheProductPolarityFeedback', updateFheProductPolarityFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('updateFheProductPolarityFeedback', updateFheProductPolarityFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('updateFheProductPolarityFeedback', updateFheProductPolarityFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('updateFheProductPolarity', { fheCenter_mac, product_identifier, module_type, code, reversePolarity });
            });
        },
        resetRelaysInversions: function (fheCenter_mac, product_identifier, module_type) {
            return new Promise((resolve, reject) => {
                let resetRelaysInversionsFeedback = args => {
                    if (
                        fheCenter_mac === args.fheCenter_mac &&
                        product_identifier === args.product_identifier &&
                        module_type === args.module_type
                    ) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('resetRelaysInversionsFeedback', resetRelaysInversionsFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('resetRelaysInversionsFeedback', resetRelaysInversionsFeedback);
                let timeout = setTimeout(function () {
                    timeout = null;
                    socketMiddleware.off('resetRelaysInversionsFeedback', resetRelaysInversionsFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('resetRelaysInversions', { fheCenter_mac, product_identifier, module_type });
            });
        },

        /**** SENSOR ****/
        getSensorWifiList: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let sensorInstallation = args => {
                    if (fheCenter_mac === args.fheCenter_mac && args.step === 'listingWiFiNetworks') {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('sensorInstallation', sensorInstallation);
                        if (!args.res.error) {
                            const res = {
                                productAP: args.res.sensor_mac.match(/.{1,2}/g).join(':'),
                                networks: args.res.networks
                            };
                            return resolve(res);
                        }

                        return reject(new Error(args.res.error.error_msg));
                    }
                };
                socketOn('sensorInstallation', sensorInstallation);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('sensorInstallation', sensorInstallation);
                    return reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('sensorWiFiList', { fheCenter_mac });
            });
        },
        startSensorInclusion: function(fheCenter_mac, network, step_callback) {
            const stepList = ['testWiFiConf', 'connectionSensorAP', 'pushWiFiConfig'];

            return new Promise((resolve, reject) => {
                let productInclusionStep = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }

                        args.step_total = stepList.length;
                        args.step_num = stepList.indexOf(args.step) + 1;
                        if (typeof step_callback === 'function') {
                            step_callback.call(this, args);
                        }

                        if (args.res.error) {
                            return reject(new Error(args.res.error_msg));
                        }

                        if (args.step === 'pushWiFiConfig') {
                            setTimeout(() => {
                                socketMiddleware.off('sensorInstallation', productInclusionStep);
                                return resolve();
                            }, 500);
                        }
                        return args;
                    }
                };

                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('sensorInstallation', productInclusionStep);
                    return reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketOn('sensorInstallation', productInclusionStep);

                socketEmit('sensorInstallation', { fheCenter_mac, network });
            });
        },
        /**** !SENSOR ****/
        /**** SMARTPLUG ****/
        getSmartPlugWifiList: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let smartPlugInclusion = args => {
                    if (fheCenter_mac === args.fheCenter_mac && args.step === 'listingWiFiNetworks') {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('smartPlugInclusion', smartPlugInclusion);
                        if (!args.res.error) {
                            const res = {
                                productAP: args.res.smartPlugAP,
                                networks: args.res.networks
                            };
                            return resolve(res);
                        }

                        return reject(new Error(args.res.error.error_msg));
                    }
                };
                socketOn('smartPlugInclusion', smartPlugInclusion);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('smartPlugInclusion', smartPlugInclusion);
                    return reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('smartPlugWifiList', { fheCenter_mac });
            });
        },
        startSmartPlugInclusion: function(fheCenter_mac, network, smartPlugAP, step_callback) {
            const stepList = ['testWiFiConf', 'connectionSmartPlugAP', 'pushWiFiConfig'];

            return new Promise((resolve, reject) => {
                let productInclusionStep = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }

                        args.step_total = stepList.length;
                        args.step_num = stepList.indexOf(args.step) + 1;
                        if (typeof step_callback === 'function') {
                            step_callback.call(this, args);
                        }

                        if (args.res.error) {
                            return reject(new Error(args.res.error_msg));
                        }

                        if (args.step === 'pushWiFiConfig') {
                            setTimeout(() => {
                                socketMiddleware.off('smartPlugInclusion', productInclusionStep);
                                return resolve();
                            }, 500);
                        }
                        return args;
                    }
                };

                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('smartPlugInclusion', productInclusionStep);
                    return reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketOn('smartPlugInclusion', productInclusionStep);

                socketEmit('smartPlugInclusion', { fheCenter_mac, network, smartPlugAP });
            });
        },
        /**** !SMARTPLUG ****/
        /**** FHEPRODUCT ****/
        getFheProductWifiList: function(fheCenter_mac) {
            const fheProduct_type = 'fheProduct';
            return new Promise((resolve, reject) => {
                let fheProductWifiList = args => {
                    if (fheCenter_mac === args.fheCenter_mac && args.fheProduct_type === fheProduct_type) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('fheProductWifiList', fheProductWifiList);
                        if (!args.error) {
                            const res = {
                                productAP: args.fheProductAP,
                                networks: args.networks.wifi_list
                            };
                            return resolve(res);
                        }
                        return reject(new Error(args.error_msg));
                    }
                };
                socketOn('fheProductWifiList', fheProductWifiList);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('fheProductWifiList', fheProductWifiList);
                    return reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('fheProductWifiList', { fheCenter_mac, fheProduct_type });
            });
        },
        startFheProductInclusion: function(fheCenter_mac, network, step_callback) {
            const fheProduct_type = 'fheProduct';

            return new Promise((resolve, reject) => {
                let productInclusionStep = args => {
                    if (fheCenter_mac === args.fheCenter_mac && args.fheProduct_type === fheProduct_type) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }

                        args.step_total = args.nb_step;
                        if (typeof step_callback === 'function') {
                            step_callback.call(this, args);
                        }

                        if (args.error) {
                            return reject(new Error(args.error_msg));
                        }

                        return args;
                    }
                };
                let productEndInclusion = args => {
                    if (fheCenter_mac === args.fheCenter_mac && fheProduct_type === args.fheProduct_type) {
                        socketMiddleware.off('fheProductStartInclusion', productInclusionStep);
                        socketMiddleware.off('fheProductEndInclusion', productEndInclusion);
                        if (!args.error) return resolve(args);
                        return reject(new Error(args.error_msg));
                    }
                };

                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('fheProductStartInclusion', productInclusionStep);
                    socketMiddleware.off('fheProductEndInclusion', productEndInclusion);
                    return reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketOn('fheProductStartInclusion', productInclusionStep);
                socketOn('fheProductEndInclusion', productEndInclusion);

                socketEmit('fheProductStartInclusion', { fheCenter_mac, network, fheProduct_type });
            });
        },
        /**** !FHEPRODUCT ****/
        /**** DRIVEELEC ****/
        getDriveElecWifiList: function(fheCenter_mac) {
            let res = {
                productAP: '',
                networks: []
            };
            return new Promise((resolve, reject) => {
                let driveElecInclusion = args => {
                    if (fheCenter_mac === args.fheCenter_mac && (args.step === 'connectionDriveElecAP' || args.step === 'listingWiFiNetworks')) {
                        if (args.res.error) {
                            if (timeout) {
                                clearTimeout(timeout);
                                timeout = null;
                            }
                            socketMiddleware.off('driveElecInclusion', driveElecInclusion);

                            reject(new Error(args.res.error.error_msg));
                        }

                        if (args.step === 'connectionDriveElecAP') {
                            res['productAP'] = args.res.driveElecAP;
                        }

                        if (args.step === 'listingWiFiNetworks') {
                            res['networks'] = args.res.networks;

                            if (timeout) {
                                clearTimeout(timeout);
                                timeout = null;
                            }
                            socketMiddleware.off('driveElecInclusion', driveElecInclusion);
                            return resolve(res);
                        }
                    }
                };
                socketOn('driveElecInclusion', driveElecInclusion);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('driveElecInclusion', driveElecInclusion);
                    return reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('driveElecWiFiList', { fheCenter_mac });
            });
        },
        startDriveElecInclusion: function(fheCenter_mac, network, step_callback) {
            return new Promise((resolve, reject) => {
                let productInclusionStep = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        const subStepObj = args.sub_step.split('/');
                        args.step_total = subStepObj[1];
                        args.step_num = subStepObj[0];
                        if (typeof step_callback === 'function') {
                            step_callback.call(this, args);
                        }

                        if (args.res.error) {
                            return reject(new Error(args.res.error_msg));
                        }

                        if (args.step_total === args.step_num) {
                            setTimeout(() => {
                                socketMiddleware.off('driveElecInclusion', productInclusionStep);
                                return resolve();
                            }, 500);
                        }
                        return args;
                    }
                };

                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('driveElecInclusion', productInclusionStep);
                    return reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketOn('driveElecInclusion', productInclusionStep);

                socketEmit('driveElecInstallation', { fheCenter_mac, network });
            });
        },
        driveElecOlimexMigration: function (fheCenter_mac, product_identifier) {
            return new Promise((resolve, reject) => {
                let driveElecOlimexMigrationFeedback = args => {
                    if (
                        fheCenter_mac === args.fheCenter_mac &&
                        product_identifier === args.product_identifier
                    ) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('driveElecOlimexMigrationFeedback', driveElecOlimexMigrationFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('driveElecOlimexMigrationFeedback', driveElecOlimexMigrationFeedback);
                let timeout = setTimeout(function () {
                    timeout = null;
                    socketMiddleware.off('driveElecOlimexMigrationFeedback', driveElecOlimexMigrationFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('driveElecOlimexMigration', { fheCenter_mac, product_identifier });
            });
        },
        /**** !DRIVEELEC ****/
        /**** HEATANDCOOL ****/
        getHeatAndCoolWifiList: function(fheCenter_mac) {
            const fheProduct_type = 'heatCool';

            let res = {
                productAP: '',
                networks: []
            };
            return new Promise((resolve, reject) => {
                let heatAndCoolInclusion = args => {
                    if (
                        fheCenter_mac === args.fheCenter_mac &&
                        fheProduct_type === args.fheProduct_type &&
                        (args.step === 'connectionFheProductAP' || args.step === 'listingWiFiNetworks')
                    ) {
                        if (args.res.error) {
                            if (timeout) {
                                clearTimeout(timeout);
                                timeout = null;
                            }
                            socketMiddleware.off('fheProductInclusion', heatAndCoolInclusion);

                            reject(new Error(args.res.error.error_msg));
                        }

                        if (args.step === 'connectionFheProductAP') {
                            res['productAP'] = args.res.fheProductAP;
                        }

                        if (args.step === 'listingWiFiNetworks') {
                            res['networks'] = args.res.networks;

                            if (timeout) {
                                clearTimeout(timeout);
                                timeout = null;
                            }
                            socketMiddleware.off('fheProductInclusion', heatAndCoolInclusion);
                            return resolve(res);
                        }
                    }
                };
                socketOn('fheProductInclusion', heatAndCoolInclusion);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('fheProductInclusion', heatAndCoolInclusion);
                    return reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('fheProductWifiList', { fheCenter_mac, fheProduct_type });
            });
        },
        startHeatAndCoolInclusion: function(fheCenter_mac, network, step_callback) {
            const fheProduct_type = 'heatCool';

            return new Promise((resolve, reject) => {
                let heatAndCoolInclusionStep = args => {
                    if (fheCenter_mac === args.fheCenter_mac && fheProduct_type === args.fheProduct_type) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        const subStepObj = args.sub_step.split('/');
                        args.step_total = subStepObj[1];
                        args.step_num = subStepObj[0];
                        if (typeof step_callback === 'function') {
                            step_callback.call(this, args);
                        }

                        if (args.res.error) {
                            return reject(new Error(args.res.error_msg));
                        }

                        if (args.step_total === args.step_num) {
                            setTimeout(() => {
                                socketMiddleware.off('fheProductInclusion', heatAndCoolInclusionStep);
                                return resolve();
                            }, 500);
                        }
                        return args;
                    }
                };

                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('fheProductInclusion', heatAndCoolInclusionStep);
                    return reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketOn('fheProductInclusion', heatAndCoolInclusionStep);

                socketEmit('fheProductInstallation', { fheCenter_mac, fheProduct_type, network });
            });
        }
        /**** !HEATANDCOOL ****/
    };
};



// WEBPACK FOOTER //
// ./environments/fhe/eventsSocket/Product/index.js